module.exports = __webpack_public_path__ + "static/fcra-2018-19-q4-5c5e030bf81a8eae1851a64c653dd694.pdf";